import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { AdviceColumnHeading } from '../../../components/advice/shared'

// Shared layout for advice steps comparing CURRENT with RECOMMENDED or YOUR CHANGES.
// Step-specific spacing belongs in that step's style.js.

export const VALUE_COLUMN_WIDTH = '190px'
export const COLUMN_GAP = '6px'
export const HEADER_TO_ROWS_GAP = '16px'
// Applied by the steps that render a sentence under a value row, not here.
export const ROW_TO_SENTENCE_GAP = '20px'

const NAME_COLUMN_PADDING = '24px'
const ROW_GROUP_GAP = '62px'

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-end;
  column-gap: ${COLUMN_GAP};
`

export const ValueColumnHeading = styled(AdviceColumnHeading)`
  width: ${VALUE_COLUMN_WIDTH};
  text-align: center;
`

// Keep the value cells centered when a wrapped name makes the row taller.
export const ValueRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${COLUMN_GAP};
`

export const RowGroups = styled.div`
  margin-top: ${HEADER_TO_ROWS_GAP};
  display: flex;
  flex-direction: column;
  row-gap: ${ROW_GROUP_GAP};
`

// Let long names wrap and increase the row height instead of overlapping the next row.
export const nameGutterStyles = css`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: ${NAME_COLUMN_PADDING};
  text-align: right;
  overflow-wrap: break-word;
`

// Match the name gutter's width and padding to keep the value columns centered.
export const BalanceGutter = styled.div`
  flex: 1 1 0;
  min-width: 0;
  padding-left: ${NAME_COLUMN_PADDING};
`
